var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-end",style:(_vm.style)},[_c('resp-img',{style:({ borderRadius: '4px' }),attrs:{"src":_vm.item.image.url}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }